(function () {
  'use strict';

  function formatAverage(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) return '5,00';
    return number.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function initReviews(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    var widget = root.querySelector('.jdgm-all-reviews-widget');
    var average = root.querySelector('[data-reviews-average]');
    var count = root.querySelector('[data-reviews-count]');
    var stars = root.querySelector('[data-reviews-stars]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-rating]'));
    var nativeWriteAction = root.querySelector('[data-native-review-action]');
    var nativeWriteLabel = root.querySelector('[data-review-action-label]');
    var initialScrollX = window.scrollX;
    var initialScrollY = window.scrollY;

    function getNativeWriteButton() {
      return widget && widget.querySelector('.jdgm-write-rev-link');
    }

    function reviewsAreLoaded() {
      var body = widget && widget.querySelector('.jdgm-all-reviews__body');
      return Boolean(body && body.querySelector('.jdgm-rev'));
    }

    function reviewFormIsOpen() {
      var nativeWriteButton = getNativeWriteButton();
      var form = widget && widget.querySelector('.jdgm-form-wrapper');
      return Boolean(
        (nativeWriteButton && nativeWriteButton.classList.contains('close-form-btn')) ||
        (form && window.getComputedStyle(form).display !== 'none')
      );
    }

    function openReviewForm() {
      var nativeWriteButton = getNativeWriteButton();
      if (!nativeWriteButton || reviewFormIsOpen()) return;
      nativeWriteButton.click();

      window.setTimeout(function () {
        var currentButton = getNativeWriteButton();
        if (!reviewFormIsOpen() && currentButton) currentButton.click();
      }, 120);

      window.setTimeout(syncWriteButton, 80);
      window.setTimeout(syncWriteButton, 300);
      window.setTimeout(syncWriteButton, 600);
    }

    function syncWriteButton() {
      var nativeWriteButton = getNativeWriteButton();
      if (!nativeWriteButton) return;
      var isOpen = nativeWriteButton.classList.contains('close-form-btn');
      var label = isOpen ? root.dataset.closeLabel : root.dataset.writeLabel;
      if (label && nativeWriteLabel && nativeWriteLabel.textContent !== label) {
        nativeWriteLabel.textContent = label;
      }
    }

    if (nativeWriteAction) {
      nativeWriteAction.addEventListener('click', function () {
        var nativeWriteButton = getNativeWriteButton();
        if (!nativeWriteButton) return;

        if (reviewFormIsOpen()) {
          nativeWriteButton.click();
          window.setTimeout(syncWriteButton, 80);
          window.setTimeout(syncWriteButton, 300);
          return;
        }

        if (reviewsAreLoaded()) {
          openReviewForm();
          return;
        }

        nativeWriteButton.click();

        var attempts = 0;
        var openWhenReady = function () {
          var currentButton = getNativeWriteButton();
          if (reviewsAreLoaded() && currentButton) {
            openReviewForm();
            return;
          }
          attempts += 1;
          if (attempts < 12) window.setTimeout(openWhenReady, 200);
        };

        window.setTimeout(openWhenReady, 150);
      });
    }

    function syncSummary() {
      var header = widget && widget.querySelector('.jdgm-all-reviews__header');
      if (!header) return false;

      var rating = header.dataset.averageRating;
      var total = header.dataset.numberOfReviews;
      if (rating) average.textContent = formatAverage(rating);
      if (total) count.textContent = new Intl.NumberFormat('es-ES').format(Number(total));
      if (rating) stars.setAttribute('aria-label', formatAverage(rating) + ' de 5 estrellas');
      return true;
    }

    function getHistogramRow(rating) {
      if (!widget) return null;
      if (rating === 'all') return widget.querySelector('.jdgm-histogram__clear-filter');
      return widget.querySelector('.jdgm-histogram__row[data-rating="' + rating + '"]');
    }

    function setActiveFilter(activeFilter) {
      filters.forEach(function (filter) {
        var active = filter === activeFilter;
        filter.classList.toggle('is-active', active);
        filter.setAttribute('aria-pressed', String(active));
      });
    }

    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        var row = getHistogramRow(filter.dataset.rating);
        if (!row) return;
        row.click();
        setActiveFilter(filter);
      });
    });

    function restoreInitialPosition() {
      var activeElement = document.activeElement;
      if (activeElement && activeElement !== document.body && typeof activeElement.blur === 'function') {
        activeElement.blur();
      }
      window.scrollTo(initialScrollX, initialScrollY);
    }

    function preloadReviews(attempt) {
      if (!widget) return;
      var reviewsBody = widget.querySelector('.jdgm-all-reviews__body');
      var renderedReview = reviewsBody && reviewsBody.querySelector('.jdgm-rev');

      if (renderedReview) {
        setActiveFilter(filters[0]);
        restoreInitialPosition();
        window.setTimeout(restoreInitialPosition, 100);
        window.setTimeout(restoreInitialPosition, 350);
        return;
      }

      var firstRating = widget.querySelector('.jdgm-histogram__row[data-rating="5"]');
      if (firstRating) firstRating.click();

      if (attempt < 10) {
        window.setTimeout(function () {
          preloadReviews(attempt + 1);
        }, 300);
      }
    }

    window.setTimeout(function () {
      preloadReviews(0);
    }, 300);

    function syncWidget(attempt) {
      var summaryReady = syncSummary();
      syncWriteButton();
      if (!summaryReady && attempt < 15) {
        window.setTimeout(function () {
          syncWidget(attempt + 1);
        }, 200);
      }
    }

    syncWidget(0);
  }

  function initAll() {
    document.querySelectorAll('[data-soliv-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
